//#region src/utils/generate-uuid.ts
function e() {
	return typeof crypto < "u" && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
}
//#endregion
export { e as generateUUID };
